export enum AttemptPeriodType {
	FromLastAttempt = 1,
	CalendarDaysUTC = 2,
	CalendarDaysUserTimeZone = 3,
	Lifetime = 4,
}